import { render, staticRenderFns } from "./ChangeMailForm.vue?vue&type=template&id=d6fba728&scoped=true&lang=pug"
import script from "./ChangeMailForm.vue?vue&type=script&lang=js"
export * from "./ChangeMailForm.vue?vue&type=script&lang=js"
import style0 from "./ChangeMailForm.vue?vue&type=style&index=0&id=d6fba728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6fba728",
  null
  
)

export default component.exports